import React, {useCallback, useEffect} from "react";
import LineChartHook from "./LineChartHook";
import {getPortfolioNetwrothGraphAPI, getPortfolioNetwrothGraphByPortfolioTypeAPI} from "../../../apihelper/portfolio";

const PortfolioChart = (props = {}) => {
    const {selectedPortfolio, portfolioId} = props;
    const [loading, setLoading] = React.useState(false);
    const [loginStatus, setLoginStatus] = React.useState(false);
    const [chartData, setChartData] = React.useState({});
    const [roiData, setRoiData] = React.useState({});
    const [portfolioName, setPortfolioName] = React.useState();
    const [portfolio_id, setPortfolio_id] = React.useState();
    const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
    const [errorData, setErrorData] = React.useState(false);
    
    React.useEffect(()=>{
        setPortfolio_id(portfolioId);
    }, [portfolioId]);
    React.useEffect(() => {
        setPortfolioName(selectedPortfolio);
        setErrorData(false);

    }, [selectedPortfolio]);



    const processApiData = (results) => {
        const data = {};
        const roiData = {};
        const dropdownOptions = [];
        const uniquePortfolios = new Set();
        let firstPortfolioId = null;

        results.forEach((row) => {
            const formattedDate = new Date(row.roi_date).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
            });

            if (!data[row.portfolio_type_id]) {
                data[row.portfolio_type_id] = {
                    dates: [],
                    values: [],
                };
            }

            data[row.portfolio_type_id].dates.push(formattedDate);
            data[row.portfolio_type_id].values.push(parseFloat((row.net_worth / 1).toFixed(1)));

            roiData[row.portfolio_type_id] = {
                full_name: row.full_name || "Portfolio",
                portfolio_name: row.portfolio_name || "Portfolio",
                one_day_roi: row.one_day_roi || "NA",
                seven_day_roi: row.seven_day_roi || "NA",
                thirty_day_roi: row.thirty_day_roi || "NA",
                ninety_day_roi: row.ninety_day_roi || "NA",
            };

            if (!uniquePortfolios.has(row.portfolio_type_id)) {
                uniquePortfolios.add(row.portfolio_type_id);

                if (!firstPortfolioId) {
                    firstPortfolioId = row.portfolio_type_id;
                }

                const displayName = `${row.portfolio_name || "Unknown Portfolio"}`;
                dropdownOptions.push({
                    id: row.portfolio_type_id,
                    name: displayName,
                });
            }
        });

        return {
            chartData: data,
            roiData,
            dropdownOptions,
            firstPortfolioId,
        };
    };


    const fetchData = useCallback(async () => {
        if (!portfolioName && userData){
            return
        }

        try {
            setLoading(true);
            const response = await getPortfolioNetwrothGraphByPortfolioTypeAPI(userData, portfolioName);
            if (response.ok) {
                const data = await response.json();
                // setIsEligible(true);

                if (Array.isArray(data)) {
                    const processedData = processApiData(data);
                    setChartData(processedData.chartData);
                    setRoiData(processedData.roiData);
                    setErrorData(false);
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error("Error: Unexpected data structure");
                }
            } else {
                setErrorData(true);
                setLoading(false);
                console.error("Error: Unexpected response code", response.status);
            }
        } catch (err) {
            setLoading(false);
            setErrorData(true);
            console.error("Error fetching data:", err);
        }
    }, [portfolioName]);

    useEffect(()=>{
        fetchData()
    }, [portfolioName]);

    return (
        <div className={`h-100 graph-container`}>
            <LineChartHook
                chartData={chartData}
                selectedPortfolio={portfolioName}
                portfolioId={portfolio_id}
                isLoggedIn={true}
                roiData={roiData}
                errorData={errorData}
            />
        </div>
    );
};

export default PortfolioChart;
